export default __webpack_public_path__ + "static/media/preview.f71f65f7.svg";